import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Brand, Category, Size, Color } from '../../shared/models/Attribute';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AttributesService {

  private apiUrl = `${environment.apiUrl}/attributes`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
  }

  //COLORES
  getColors(): Observable<Color[]> {
    return this.http.get<Color[]>(`${this.apiUrl}/colors`);
  }

  getActiveColors(): Observable<Color[]> {
    return this.http.get<Color[]>(`${this.apiUrl}/colors/active`);
  }

  createColor(color: Color): Observable<Color> {
    return this.http.post<Color>(`${this.apiUrl}/colors`, color, this.getHeaders());
  }

  updateColor(id: number, color: Color): Observable<Color> {
    return this.http.put<Color>(`${this.apiUrl}/colors/${id}`, color, this.getHeaders());
  }

  toggleColor(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/colors/${id}`, this.getHeaders());
  }

  //TALLAS
  getActiveSizes(): Observable<Size[]> {
    return this.http.get<Size[]>(`${this.apiUrl}/sizes/active`);
  }

  getSizes(): Observable<Size[]> {
    return this.http.get<Size[]>(`${this.apiUrl}/sizes`);
  }

  createSize(size: Size): Observable<Size> {
    return this.http.post<Size>(`${this.apiUrl}/sizes`, size, this.getHeaders());
  }

  updateSize(id: number, size: Size): Observable<Size> {
    return this.http.put<Size>(`${this.apiUrl}/sizes/${id}`, size, this.getHeaders());
  }

  toggleSize(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/sizes/${id}`, this.getHeaders());
  }

  //MARCAS
  getActiveBrands(): Observable<Brand[]> {
    return this.http.get<Brand[]>(`${this.apiUrl}/brands/active`);
  }

  getBrands(): Observable<Brand[]> {
    return this.http.get<Brand[]>(`${this.apiUrl}/brands`);
  }

  createBrand(brand: Brand): Observable<Brand> {
    return this.http.post<Brand>(`${this.apiUrl}/brands`, brand, this.getHeaders());
  }

  updateBrand(id: number, brand: Brand): Observable<Brand> {
    return this.http.put<Brand>(`${this.apiUrl}/brands/${id}`, brand, this.getHeaders());
  }

  toggleBrand(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/brands/${id}`, this.getHeaders());
  }

  //CATEGORIAS
  getActiveCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.apiUrl}/categories/active`);
  }

  getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.apiUrl}/categories`);
  }

  createCategory(cat: Category): Observable<Category> {
    return this.http.post<Category>(`${this.apiUrl}/categories`, cat, this.getHeaders());
  }

  updateCategory(id: number, cat: Category): Observable<Category> {
    return this.http.put<Category>(`${this.apiUrl}/categories/${id}`, cat, this.getHeaders());
  }

  toggleCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/categories/${id}`, this.getHeaders());
  }

  getActiveModels(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/modelos/active`);
  }
}
